"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5637],{

/***/ 88094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ ChatInterface; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/api/index.ts + 2 modules
var api = __webpack_require__(53249);
// EXTERNAL MODULE: ./src/hook/useUser.ts + 1 modules
var useUser = __webpack_require__(92859);
// EXTERNAL MODULE: ./src/state/index.ts
var state = __webpack_require__(51413);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/api/error.ts
var api_error = __webpack_require__(67514);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/bot.js
var bot = __webpack_require__(71581);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/x.js
var x = __webpack_require__(41352);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/user.js
var icons_user = __webpack_require__(94933);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/send.js
var send = __webpack_require__(42841);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/circle-check-big.js
var circle_check_big = __webpack_require__(9589);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-gtm-module/dist/index.js
var dist = __webpack_require__(1785);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var recoil_es = __webpack_require__(4480);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 1 modules
var v4 = __webpack_require__(82170);
// EXTERNAL MODULE: ./src/component/v2/base/button.tsx
var base_button = __webpack_require__(26623);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
;// CONCATENATED MODULE: ./src/component/v2/base/card.tsx





var Card = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)("div", (0,_object_spread/* default */.Z)({
        ref: ref,
        className: (0,utils.cn)("rounded-lg border bg-card text-card-foreground shadow-sm", className)
    }, props));
});
Card.displayName = "Card";
var CardHeader = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)("div", (0,_object_spread/* default */.Z)({
        ref: ref,
        className: (0,utils.cn)("flex flex-col space-y-1.5 p-6", className)
    }, props));
});
CardHeader.displayName = "CardHeader";
var CardTitle = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)("div", (0,_object_spread/* default */.Z)({
        ref: ref,
        className: (0,utils.cn)("text-2xl font-semibold leading-none tracking-tight", className)
    }, props));
});
CardTitle.displayName = "CardTitle";
var CardDescription = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)("div", (0,_object_spread/* default */.Z)({
        ref: ref,
        className: (0,utils.cn)("text-sm text-muted-foreground", className)
    }, props));
});
CardDescription.displayName = "CardDescription";
var CardContent = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)("div", (0,_object_spread/* default */.Z)({
        ref: ref,
        className: (0,utils.cn)("p-6 pt-0", className)
    }, props));
});
CardContent.displayName = "CardContent";
var CardFooter = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)("div", (0,_object_spread/* default */.Z)({
        ref: ref,
        className: (0,utils.cn)("flex items-center p-6 pt-0", className)
    }, props));
});
CardFooter.displayName = "CardFooter";


;// CONCATENATED MODULE: ./src/component/v2/base/textarea.tsx





var Textarea = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)("textarea", (0,_object_spread/* default */.Z)({
        className: (0,utils.cn)("flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", className),
        ref: ref
    }, props));
});
Textarea.displayName = "Input";


;// CONCATENATED MODULE: ./src/component/v2/ChatInterface.tsx



















// ANSI 이스케이프 코드를 제거하는 함수
var removeAnsiCodes = function(text) {
    // ANSI 이스케이프 시퀀스 제거 (예: [1m, [0m, [31m 등)
    return text.replace(/\u001b\[[0-9;]*m/g, "");
};
// URL을 링크로 변환하는 함수
var convertUrlsToLinks = function(text) {
    var isUserMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    // 먼저 ANSI 이스케이프 코드 제거
    var cleanedText = removeAnsiCodes(text);
    // URL 패턴 수정: 도메인과 경로만 포함하고 뒤에 붙은 한글은 제외
    var urlRegex = /(https?:\/\/[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+[^\s가-힣]*)/g;
    if (!urlRegex.test(cleanedText)) return cleanedText;
    return cleanedText.split(urlRegex).map(function(part, index) {
        if (part.match(urlRegex)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: part,
                target: "_blank",
                rel: "noopener noreferrer",
                className: isUserMessage ? "text-white hover:underline" : "text-blue-600 hover:underline",
                children: part
            }, index);
        }
        return part;
    });
};
function ChatInterface(param) {
    var userInfo = param.userInfo, onClose = param.onClose, isOpen = param.isOpen, defaultMessage = param.defaultMessage;
    var messages = (0,recoil_es/* useRecoilValue */.sJ)(state/* messagesAtom */.qw);
    var setMessages = (0,recoil_es/* useSetRecoilState */.Zl)(state/* messagesAtom */.qw);
    var ref = (0,react.useState)(""), currentInput = ref[0], setCurrentInput = ref[1];
    var setResultData = (0,recoil_es/* useSetRecoilState */.Zl)(state/* aiConsultResultDataAtom */.go);
    var messagesEndRef = (0,react.useRef)(null);
    var resultData = (0,recoil_es/* useRecoilValue */.sJ)(state/* aiConsultResultDataAtom */.go);
    var queryClient = (0,es.useQueryClient)();
    var user = (0,useUser/* default */.Z)().user;
    var router = (0,next_router.useRouter)();
    var setInitPage = (0,recoil_es/* useSetRecoilState */.Zl)(state/* initPage */.df);
    var setSnackbareState = (0,recoil_es/* useSetRecoilState */.Zl)(state/* globalSnackbarState */.j8);
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(false), isApplyLoading = ref2[0], setIsApplyLoading = ref2[1];
    var aiMatchUuid = (0,recoil_es/* useRecoilValue */.sJ)(state/* aiMatchUuidAtom */.MC);
    var setAiMatchUuid = (0,recoil_es/* useSetRecoilState */.Zl)(state/* aiMatchUuidAtom */.MC);
    (0,react.useEffect)(function() {
        if (isOpen) {
            setAiMatchUuid((0,v4/* default */.Z)());
            setMessages([]);
        }
    }, [
        isOpen
    ]);
    var scrollToBottom = function() {
        var ref;
        (ref = messagesEndRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
            behavior: "smooth"
        });
    };
    (0,react.useEffect)(function() {
        scrollToBottom();
    }, [
        messages
    ]);
    var handleClose = function() {
        // 상태 초기화
        setMessages([]);
        setIsApplyLoading(false);
        onClose();
    };
    var handleSendMessage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var lastChatHistory, lastMessage, _tmp, resultResponse, result, chatResultToFindPromptInject, _tmp1, _tmp2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (isLoading) return [
                            2
                        ];
                        setIsLoading(true);
                        lastChatHistory = (0,_to_consumable_array/* default */.Z)(messages);
                        lastMessage = currentInput;
                        _tmp = {};
                        setMessages((0,_to_consumable_array/* default */.Z)(lastChatHistory).concat([
                            (_tmp.role = "user", _tmp.content = [
                                {
                                    type: "input_text",
                                    text: lastMessage
                                }, 
                            ], _tmp)
                        ]));
                        setCurrentInput("");
                        return [
                            4,
                            (0,api/* chatConsult */.sL)(lastMessage, messages, aiMatchUuid, userInfo)
                        ];
                    case 1:
                        resultResponse = _state.sent();
                        result = resultResponse;
                        _tmp1 = {};
                        _tmp2 = {};
                        if (result) {
                            // 프롬프트 주입 공격 방지
                            try {
                                chatResultToFindPromptInject = result[result.length - 1];
                                if (JSON.parse(chatResultToFindPromptInject.content[0].text).isDetectedPromptInjectedAttack) {
                                    setMessages([]);
                                    setAiMatchUuid((0,v4/* default */.Z)());
                                    setIsLoading(false);
                                    (0,api_error/* sendSlackError */.N)((_tmp1.message = "채팅 문제발생: ".concat(lastMessage, "\n\n회사명: ").concat(userInfo.companyName, "\n\n이름: ").concat(userInfo.name, "\n이메일: ").concat(userInfo.email, "\n전화번호: ").concat(userInfo.phone), _tmp1.title = "AI 채팅 문제 발생", _tmp1));
                                    handleClose();
                                    setSnackbareState("정책 위반으로 대화를 종료합니다");
                                    return [
                                        2
                                    ];
                                }
                            } catch (error) {
                            // console.error(error);
                            }
                            setMessages((0,_to_consumable_array/* default */.Z)(lastChatHistory).concat([
                                (_tmp2.role = "user", _tmp2.content = [
                                    {
                                        type: "input_text",
                                        text: lastMessage
                                    }, 
                                ], _tmp2)
                            ], (0,_to_consumable_array/* default */.Z)(result)));
                            setResultData(JSON.parse(result[result.length - 1].content[0].text));
                        } else {
                            setMessages((0,_to_consumable_array/* default */.Z)(lastChatHistory));
                        }
                        setIsLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSendMessage() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleKeyPress = function(e) {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSendMessage();
        }
    };
    var handleSubmitRequest = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(callback, isAiLead) {
            var result, _tmp, url, tagManagerArgs, _tmp1, error, _tmp2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (isApplyLoading) return [
                            2
                        ];
                        setIsApplyLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            9
                        ]);
                        _tmp = {};
                        return [
                            4,
                            (0,api/* leadWithAi */.dC)((_tmp.userInfo = {
                                name: userInfo.name,
                                email: userInfo.email,
                                phone: userInfo.phone.replace(/-/g, ""),
                                companyName: userInfo.companyName,
                                industry: userInfo.industry,
                                companySize: userInfo.companySize,
                                position: userInfo.position,
                                route: userInfo.route,
                                routeDetail: userInfo.routeDetail,
                                inviteCode: userInfo.inviteCode
                            }, _tmp.matchUuid = aiMatchUuid, _tmp.isAiLead = isAiLead, _tmp))
                        ];
                    case 2:
                        result = _state.sent();
                        if (!(result && result.isExistingUser && result.matchUuid)) return [
                            3,
                            6
                        ];
                        if (!user.isLogin) return [
                            3,
                            4
                        ];
                        // 로그인 상태: 업무요청서 수정 페이지로 이동
                        if (isAiLead === false) {
                            setSnackbareState("신청해주셔서 감사드립니다. 빠른 시일내에 컨설턴트가 전화 드리도록 하겠습니다.\n전화전 직접 수정도 가능하시니 기입 가능한 부분은 작성 부탁드립니다.");
                        } else {
                            setSnackbareState("매칭 신청서 수정 및 제출을 진행해주세요.");
                        }
                        return [
                            4,
                            queryClient.invalidateQueries("getMatchs")
                        ];
                    case 3:
                        _state.sent();
                        router.push("/match/my/?st=1&mid=".concat(result.matchUuid, "&edid=-&isAiLead=").concat(isAiLead ? "true" : "false"));
                        return [
                            3,
                            5
                        ];
                    case 4:
                        // 비로그인 상태: 모두 팝업 표시
                        setInitPage("/match/my/?st=1&mid=".concat(result.matchUuid, "&edid=-&isAiLead=").concat(isAiLead ? "true" : "false"));
                        if (isAiLead === true) {
                            // isAiLead === true: 기존 팝업 메시지
                            router.push("/signin?type=client&showInfoDialog=true&dialogType=default&isAiLead=true");
                        } else {
                            // isAiLead === false: 전화 상담 요청 메시지
                            router.push("/signin?type=client&showInfoDialog=true&dialogType=phoneConsult&isAiLead=false");
                        }
                        _state.label = 5;
                    case 5:
                        handleClose();
                        // 기존고객사는 여기서 함수 종료
                        return [
                            2
                        ];
                    case 6:
                        // 무비번 & 신규 고객사: 백엔드가 내려준 registerUrl로 회원가입 이동
                        if (result === null || result === void 0 ? void 0 : result.registerUrl) {
                            url = new URL(result.registerUrl);
                            // local 환경에서는 localhost로 변환
                            if (url.hostname === "1point.kr" && window.location.hostname === "localhost") {
                                url = new URL(url.pathname + url.search, "http://".concat(window.location.host));
                            }
                            if (isAiLead === false) {
                                url.searchParams.set("dialogType", "phoneConsult");
                            } else {
                                url.searchParams.set("dialogType", "signup");
                            }
                            // isAiLead 파라미터 추가 (회원가입 후 스낵바 표시용)
                            url.searchParams.set("isAiLead", isAiLead ? "true" : "false");
                            window.location.href = url.toString();
                            return [
                                2
                            ];
                        }
                        // fallback: isAiLead에 따라 다른 메시지 표시
                        if (isAiLead === false) {
                            setSnackbareState("신청해주셔서 감사드립니다. 빠른 시일내에 컨설턴트가 전화 드리도록 하겠습니다.\n전화전 직접 수정도 가능하시니 기입 가능한 부분은 작성 부탁드립니다.");
                        } else {
                            setSnackbareState("상담 신청이 완료되었습니다.\n담당 컨설턴트가 영업일 기준 2일 내로 전화 드리겠습니다.");
                        }
                        _tmp1 = {};
                        tagManagerArgs = (_tmp1.dataLayer = {
                            event: "client-apply-end",
                            event_id: aiMatchUuid
                        }, _tmp1);
                        if (!window.localStorage.getItem("accessToken")) {
                            dist_default().dataLayer(tagManagerArgs);
                        }
                        if (callback) {
                            callback();
                        }
                        queryClient.refetchQueries([
                            "getMatchs"
                        ]);
                        handleClose();
                        return [
                            3,
                            9
                        ];
                    case 7:
                        error = _state.sent();
                        _tmp2 = {};
                        (0,api_error/* sendSlackError */.N)((_tmp2.message = "회사명: ".concat(userInfo.companyName, "\n\n이름: ").concat(userInfo.name, "\n이메일: ").concat(userInfo.email, "\n전화번호: ").concat(userInfo.phone), _tmp2.title = "AI 신청 문제 발생", _tmp2));
                        return [
                            3,
                            9
                        ];
                    case 8:
                        setIsApplyLoading(false);
                        return [
                            7
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmitRequest(callback, isAiLead) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center md:p-4 z-[99999] ".concat(isOpen ? "block" : "hidden"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
            className: "w-full h-full md:max-w-[1200px] md:h-[1200px] md:max-h-[80vh] flex flex-col bg-white",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between p-4 border-b",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center space-x-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bot/* default */.Z, {
                                        className: "w-6 h-6 text-white"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "font-semibold",
                                            children: "원포인트 AI 컨설턴트"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm text-slate-500",
                                            children: "전문가 매칭 상담"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(base_button/* Button */.z, {
                            variant: "ghost",
                            size: "sm",
                            onClick: handleClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(x/* default */.Z, {
                                className: "w-4 h-4"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-1 overflow-y-auto p-4 space-y-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-start space-x-2 max-w-[80%]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-8 h-8 bg-slate-200 rounded-full flex items-center justify-center shrink-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bot/* default */.Z, {
                                        className: "w-4 h-4 text-slate-600"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "bg-slate-100 rounded-lg p-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-sm",
                                        children: defaultMessage ? defaultMessage : "안녕하세요 원포인트 AI 컨설턴트입니다. \uD83D\uDE42\n\n지금부터 전문가 매칭 정확도를 2배 높이는 업무 요청서 초안을 만들어 드릴게요.\n혹시 내용이 부족하면 컨설턴트가 연락을 드리니 너무 걱정 마시고 편하게 완성해주세요.\n\n현재 상황이나 고민하고 계신 부분이 무엇이신가요?"
                                    })
                                })
                            ]
                        }),
                        messages.filter(function(message) {
                            return message.type === "message" || message.role === "user";
                        }).map(function(message) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex ".concat(message.role === "user" ? "justify-end" : "justify-start"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-start space-x-2 max-w-[80%] ".concat(message.role === "user" ? "flex-row-reverse space-x-reverse" : ""),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-8 h-8 rounded-full flex items-center justify-center shrink-0 ".concat(message.role === "user" ? "bg-blue-600" : "bg-slate-200"),
                                            children: message.role === "user" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_user/* default */.Z, {
                                                className: "w-4 h-4 text-white"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(bot/* default */.Z, {
                                                className: "w-4 h-4 text-slate-600"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "rounded-lg p-3 ".concat(message.role === "user" ? "bg-blue-600 text-white" : "bg-slate-100 text-slate-800"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-sm",
                                                children: message.role === "assistant" ? convertUrlsToLinks(JSON.parse(message.content[0].text).nextMessage) : convertUrlsToLinks(message.content[0].text, true)
                                            })
                                        })
                                    ]
                                })
                            }, message.id);
                        }),
                        isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-start",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-start space-x-2 max-w-[80%]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-8 h-8 bg-slate-200 rounded-full flex items-center justify-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bot/* default */.Z, {
                                            className: "w-4 h-4 text-slate-600"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bg-slate-100 rounded-lg p-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex space-x-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-2 h-2 bg-slate-400 rounded-full animate-bounce"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-2 h-2 bg-slate-400 rounded-full animate-bounce",
                                                    style: {
                                                        animationDelay: "0.1s"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-2 h-2 bg-slate-400 rounded-full animate-bounce",
                                                    style: {
                                                        animationDelay: "0.2s"
                                                    }
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: messagesEndRef
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-xs text-slate-500 text-center mb-2",
                    children: "AI는 실수를 할 수 있습니다. 중요한 정보는 재차 확인하세요!"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "p-4 border-t",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex space-x-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea, {
                                value: currentInput,
                                onChange: function(e) {
                                    return setCurrentInput(e.target.value);
                                },
                                onKeyPress: handleKeyPress,
                                placeholder: "메시지를 입력하세요...",
                                className: "flex-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(base_button/* Button */.z, {
                                onClick: handleSendMessage,
                                isLoading: isLoading,
                                disabled: !currentInput.trim(),
                                className: "bg-blue-600 hover:bg-blue-700",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(send/* default */.Z, {
                                    className: "w-4 h-4"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "p-4 border-t bg-slate-50",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col md:flex-row gap-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_button/* Button */.z, {
                                    onClick: function() {
                                        handleSubmitRequest(function() {
                                            handleClose();
                                        }, true);
                                    },
                                    isLoading: isApplyLoading,
                                    className: "w-full md:w-[70%] bg-blue-600 hover:bg-blue-700 text-white",
                                    size: "lg",
                                    id: "consult-submit-request-button",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(circle_check_big/* default */.Z, {
                                            className: "w-5 h-5 mr-2"
                                        }),
                                        defaultMessage ? "AI 초안으로 매칭 시작하기 (매칭 정확도 2배 ↑)" : "AI 초안으로 매칭 시작하기 (매칭 정확도 2배 ↑)"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(base_button/* Button */.z, {
                                    onClick: function() {
                                        handleSubmitRequest(function() {
                                            handleClose();
                                        }, false);
                                    },
                                    isLoading: isApplyLoading,
                                    variant: "outline",
                                    className: "w-full md:w-[30%] border-gray-1200 hover:bg-gray-100",
                                    size: "lg",
                                    style: {
                                        color: "#666666"
                                    },
                                    children: defaultMessage ? "전화 상담 요청 후 대기하기" : "전화 상담 요청 후 대기하기"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-xs text-slate-500 text-center mt-3",
                            children: "버튼을 클릭하시면 수정 페이지로 이동합니다."
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 90244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LeadCaptureModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/api/index.ts + 2 modules
var api = __webpack_require__(53249);
// EXTERNAL MODULE: ./src/state/index.ts
var state = __webpack_require__(51413);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/x.js
var x = __webpack_require__(41352);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(4480);
// EXTERNAL MODULE: ./src/model/signupAndApplyModel.ts
var signupAndApplyModel = __webpack_require__(82112);
// EXTERNAL MODULE: ./src/component/v2/base/button.tsx
var base_button = __webpack_require__(26623);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-dialog/dist/index.mjs + 42 modules
var dist = __webpack_require__(93771);
;// CONCATENATED MODULE: ./src/component/v2/base/dialog.tsx
"use client";






var Dialog = dist/* Root */.fC;
var DialogTrigger = dist/* Trigger */.xz;
var DialogPortal = dist/* Portal */.h_;
var DialogClose = dist/* Close */.x8;
var DialogOverlay = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(dist/* Overlay */.aV, (0,_object_spread/* default */.Z)({
        ref: ref,
        className: "fixed inset-0 z-[99999] bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 ".concat(className)
    }, props));
});
DialogOverlay.displayName = dist/* Overlay.displayName */.aV.displayName;
var DialogContent = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "children"
    ]);
    return (0,jsx_runtime.jsxs)(DialogPortal, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogOverlay, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Content */.VY, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ref: ref,
                className: "fixed left-[50%] top-[50%] z-[99999] grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg ".concat(className)
            }, props), {
                children: children
            }))
        ]
    });
});
DialogContent.displayName = dist/* Content.displayName */.VY.displayName;
var DialogHeader = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)("div", (0,_object_spread/* default */.Z)({
        className: "flex flex-col space-y-1.5 text-center sm:text-left ".concat(className)
    }, props));
};
DialogHeader.displayName = "DialogHeader";
var DialogFooter = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)("div", (0,_object_spread/* default */.Z)({
        className: "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2 ".concat(className)
    }, props));
};
DialogFooter.displayName = "DialogFooter";
var DialogTitle = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(dist/* Title */.Dx, (0,_object_spread/* default */.Z)({
        ref: ref,
        className: "text-lg font-semibold leading-none tracking-tight ".concat(className)
    }, props));
});
DialogTitle.displayName = dist/* Title.displayName */.Dx.displayName;
var DialogDescription = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(dist/* Description */.dk, (0,_object_spread/* default */.Z)({
        ref: ref,
        className: "text-sm text-muted-foreground ".concat(className)
    }, props));
});
DialogDescription.displayName = dist/* Description.displayName */.dk.displayName;


// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
;// CONCATENATED MODULE: ./src/component/v2/base/input.tsx





var Input = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, type = _param.type, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "type"
    ]);
    return (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
        type: type,
        className: (0,utils.cn)("flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", className),
        ref: ref
    }, props));
});
Input.displayName = "Input";


// EXTERNAL MODULE: ./node_modules/@radix-ui/react-label/dist/index.mjs + 3 modules
var react_label_dist = __webpack_require__(41850);
// EXTERNAL MODULE: ./node_modules/class-variance-authority/dist/index.mjs
var class_variance_authority_dist = __webpack_require__(12003);
;// CONCATENATED MODULE: ./src/component/v2/base/label.tsx







var labelVariants = (0,class_variance_authority_dist/* cva */.j)("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70");
var Label = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(react_label_dist/* Root */.f, (0,_object_spread/* default */.Z)({
        ref: ref,
        className: (0,utils.cn)(labelVariants(), className)
    }, props));
});
Label.displayName = react_label_dist/* Root.displayName */.f.displayName;


// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/chevron-down.js
var chevron_down = __webpack_require__(8971);
;// CONCATENATED MODULE: ./src/component/v2/base/select.tsx







var Select = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, error = _param.error, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "error",
        "children"
    ]);
    return (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: (0,utils.cn)("flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 appearance-none", error && "border-red-500", className),
                ref: ref
            }, props), {
                children: children
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_down/* default */.Z, {
                className: "absolute right-3 top-3 h-4 w-4 opacity-50 pointer-events-none"
            })
        ]
    });
});
Select.displayName = "Select";


;// CONCATENATED MODULE: ./src/component/v2/LeadCaptureModal.tsx

















function LeadCaptureModal(param) {
    var isOpen = param.isOpen, onClose = param.onClose, onSubmit = param.onSubmit;
    var ref = (0,react.useState)({
        name: "",
        phone: "",
        email: "",
        companyName: "",
        industry: "",
        companySize: "",
        position: "",
        route: "",
        routeDetail: "",
        inviteCode: ""
    }), formData = ref[0], setFormData = ref[1];
    var ref1 = (0,react.useState)({}), errors = ref1[0], setErrors = ref1[1];
    var matchUuid = (0,es/* useRecoilValue */.sJ)(state/* aiMatchUuidAtom */.MC);
    var validateForm = function() {
        var newErrors = {};
        if (!formData.companyName.trim()) {
            newErrors.companyName = "회사명을 입력해주세요";
        }
        if (!formData.name.trim()) {
            newErrors.name = "이름을 입력해주세요";
        }
        if (!formData.phone.trim()) {
            newErrors.phone = "전화번호를 입력해주세요";
        } else if (!/^[0-9-+\s()]+$/.test(formData.phone)) {
            newErrors.phone = "올바른 전화번호를 입력해주세요";
        }
        if (!formData.email.trim()) {
            newErrors.email = "이메일을 입력해주세요";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = "올바른 이메일을 입력해주세요";
        }
        if (!formData.industry) {
            newErrors.industry = "산업군을 선택해주세요";
        }
        if (!formData.companySize) {
            newErrors.companySize = "기업규모를 선택해주세요";
        }
        if (!formData.position) {
            newErrors.position = "직책을 선택해주세요";
        }
        if (!formData.route) {
            newErrors.route = "경로를 선택해주세요";
        }
        if (formData.route === "기타" && !formData.routeDetail.trim()) {
            newErrors.routeDetail = "경로 상세를 입력해주세요";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var emailCheckResult, _tmp, submitData, _tmp1, _tmp2, _tmp3, _tmp4;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if (!validateForm()) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,api/* checkUserTypeByEmail */.Vz)(formData.email)
                        ];
                    case 1:
                        emailCheckResult = _state.sent();
                        _tmp = {};
                        if (emailCheckResult.isExpert) {
                            setErrors((_tmp.email = emailCheckResult.message, _tmp));
                            return [
                                2
                            ];
                        }
                        _tmp1 = {};
                        _tmp2 = {};
                        submitData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp1, formData), (_tmp2.routeDetail = formData.route === "기타" ? formData.routeDetail : "", _tmp2));
                        onSubmit(submitData);
                        _tmp3 = {};
                        setFormData((_tmp3.name = "", _tmp3.phone = "", _tmp3.email = "", _tmp3.companyName = "", _tmp3.industry = "", _tmp3.companySize = "", _tmp3.position = "", _tmp3.route = "", _tmp3.routeDetail = "", _tmp3.inviteCode = "", _tmp3));
                        _tmp4 = {};
                        setErrors(_tmp4);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleInputChange = function(field, value) {
        setFormData(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, field, value));
        });
        if (errors[field]) {
            setErrors(function(prev) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, field, ""));
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog, {
        open: isOpen,
        onOpenChange: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent, {
            className: "sm:max-w-md bg-white max-h-[90vh] overflow-y-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogHeader, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle, {
                                className: "text-xl font-semibold",
                                children: "상담을 하려면 기본 정보가 필요해요!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(base_button/* Button */.z, {
                                variant: "ghost",
                                size: "sm",
                                onClick: onClose,
                                className: "h-6 w-6 p-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(x/* default */.Z, {
                                    className: "h-4 w-4"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-sm text-slate-600",
                            children: "기본 정보를 입력해주세요"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            onSubmit: handleSubmit,
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                            htmlFor: "companyName",
                                            children: "회사명 *"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                            id: "companyName",
                                            type: "text",
                                            placeholder: "회사명",
                                            value: formData.companyName,
                                            onChange: function(e) {
                                                return handleInputChange("companyName", e.target.value);
                                            },
                                            className: errors.companyName ? "border-red-500" : ""
                                        }),
                                        errors.companyName && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm text-red-500",
                                            children: errors.companyName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                            htmlFor: "name",
                                            children: "이름 *"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                            id: "name",
                                            type: "text",
                                            placeholder: "홍길동",
                                            value: formData.name,
                                            onChange: function(e) {
                                                return handleInputChange("name", e.target.value);
                                            },
                                            className: errors.name ? "border-red-500" : ""
                                        }),
                                        errors.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm text-red-500",
                                            children: errors.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                            htmlFor: "phone",
                                            children: "전화번호 *"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                            id: "phone",
                                            type: "tel",
                                            placeholder: "010-1234-5678",
                                            value: formData.phone,
                                            onChange: function(e) {
                                                return handleInputChange("phone", e.target.value);
                                            },
                                            className: errors.phone ? "border-red-500" : ""
                                        }),
                                        errors.phone && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm text-red-500",
                                            children: errors.phone
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                            htmlFor: "email",
                                            children: "이메일 *"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                            id: "email",
                                            type: "email",
                                            placeholder: "example@company.com",
                                            value: formData.email,
                                            onChange: function(e) {
                                                return handleInputChange("email", e.target.value);
                                            },
                                            className: errors.email ? "border-red-500" : ""
                                        }),
                                        errors.email && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm text-red-500",
                                            children: errors.email
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                            htmlFor: "position",
                                            children: "직책 *"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select, {
                                            id: "position",
                                            value: formData.position,
                                            onChange: function(e) {
                                                return handleInputChange("position", e.target.value);
                                            },
                                            error: !!errors.position,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "",
                                                    children: "직책을 선택해주세요"
                                                }),
                                                signupAndApplyModel/* positionOptionArray.map */.yE.map(function(option) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: option,
                                                        children: option
                                                    }, option);
                                                })
                                            ]
                                        }),
                                        errors.position && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm text-red-500",
                                            children: errors.position
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                            htmlFor: "industry",
                                            children: "산업군 *"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select, {
                                            id: "industry",
                                            value: formData.industry,
                                            onChange: function(e) {
                                                return handleInputChange("industry", e.target.value);
                                            },
                                            error: !!errors.industry,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "",
                                                    children: "산업군을 선택해주세요"
                                                }),
                                                signupAndApplyModel/* companyIndustryOptionArray.map */.dg.map(function(option) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: option,
                                                        children: option
                                                    }, option);
                                                })
                                            ]
                                        }),
                                        errors.industry && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm text-red-500",
                                            children: errors.industry
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                            htmlFor: "companySize",
                                            children: "기업규모 *"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select, {
                                            id: "companySize",
                                            value: formData.companySize,
                                            onChange: function(e) {
                                                return handleInputChange("companySize", e.target.value);
                                            },
                                            error: !!errors.companySize,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "",
                                                    children: "기업규모를 선택해주세요"
                                                }),
                                                signupAndApplyModel/* companySizeOptionArray.map */.q1.map(function(option) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: option,
                                                        children: option
                                                    }, option);
                                                })
                                            ]
                                        }),
                                        errors.companySize && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm text-red-500",
                                            children: errors.companySize
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                            htmlFor: "route",
                                            children: "알게 된 경로 *"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select, {
                                            id: "route",
                                            value: formData.route,
                                            onChange: function(e) {
                                                return handleInputChange("route", e.target.value);
                                            },
                                            error: !!errors.route,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "",
                                                    children: "알게 된 경로를 선택해주세요"
                                                }),
                                                signupAndApplyModel/* routeOptionArray.map */.QE.map(function(option) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: option,
                                                        children: option
                                                    }, option);
                                                })
                                            ]
                                        }),
                                        errors.route && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm text-red-500",
                                            children: errors.route
                                        })
                                    ]
                                }),
                                formData.route === "기타" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                            htmlFor: "routeDetail",
                                            children: "경로 상세 *"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                            id: "routeDetail",
                                            type: "text",
                                            placeholder: "경로를 입력해주세요",
                                            value: formData.routeDetail,
                                            onChange: function(e) {
                                                return handleInputChange("routeDetail", e.target.value);
                                            },
                                            className: errors.routeDetail ? "border-red-500" : ""
                                        }),
                                        errors.routeDetail && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm text-red-500",
                                            children: errors.routeDetail
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                            htmlFor: "inviteCode",
                                            children: "추천코드 (선택사항)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                            id: "inviteCode",
                                            type: "text",
                                            placeholder: "추천코드를 입력해주세요",
                                            value: formData.inviteCode,
                                            onChange: function(e) {
                                                return handleInputChange("inviteCode", e.target.value);
                                            },
                                            className: errors.inviteCode ? "border-red-500" : ""
                                        }),
                                        errors.inviteCode && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm text-red-500",
                                            children: errors.inviteCode
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(base_button/* Button */.z, {
                                    type: "submit",
                                    className: "w-full bg-blue-600 hover:bg-blue-700 text-white",
                                    id: "lead-capture-modal-submit-button",
                                    children: "상담 시작하기"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-xs text-slate-500 text-center",
                            children: "입력하신 정보는 상담 목적으로 사용되며, 안전하게 보호됩니다."
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 26623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony export buttonVariants */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61465);
/* harmony import */ var class_variance_authority__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12003);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93293);








var buttonVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_3__/* .cva */ .j)("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0", {
    variants: {
        variant: {
            default: "bg-primary text-primary-foreground hover:bg-primary/90",
            destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
            outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
            secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
            ghost: "hover:bg-accent hover:text-accent-foreground",
            link: "text-primary underline-offset-4 hover:underline"
        },
        size: {
            default: "h-10 px-4 py-2",
            sm: "h-9 rounded-md px-3",
            lg: "h-11 rounded-md px-8",
            icon: "h-10 w-10"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});
var Button = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, variant = _param.variant, size = _param.size, _asChild = _param.asChild, asChild = _asChild === void 0 ? false : _asChild, _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, children = _param.children, disabled = _param.disabled, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "className",
        "variant",
        "size",
        "asChild",
        "isLoading",
        "children",
        "disabled"
    ]);
    var Comp = asChild ? _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_5__/* .Slot */ .g7 : "button";
    var isNativeButton = !asChild;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: (0,_utils__WEBPACK_IMPORTED_MODULE_2__.cn)(buttonVariants({
            variant: variant,
            size: size,
            className: className
        }), "relative", isLoading && "cursor-wait pointer-events-none"),
        ref: ref,
        "aria-busy": isLoading
    }, isNativeButton ? {
        disabled: Boolean(isLoading || disabled)
    } : {}, props), {
        children: isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            className: "h-4 w-4 animate-spin",
            viewBox: "0 0 24 24",
            "aria-hidden": "true",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    className: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    strokeWidth: "4",
                    fill: "none"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                })
            ]
        }) : children
    }));
});
Button.displayName = "Button";



/***/ }),

/***/ 82112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ey": function() { return /* binding */ desiredStartDateOptionArray; },
/* harmony export */   "G2": function() { return /* binding */ matchJobOptionArray; },
/* harmony export */   "I6": function() { return /* binding */ estimatedBusinessDurationOptionArray; },
/* harmony export */   "QE": function() { return /* binding */ routeOptionArray; },
/* harmony export */   "_A": function() { return /* binding */ matchMonthBudgetOptionArray; },
/* harmony export */   "cb": function() { return /* binding */ expectedWorkloadOptionArray; },
/* harmony export */   "dg": function() { return /* binding */ companyIndustryOptionArray; },
/* harmony export */   "gA": function() { return /* binding */ matchPurposeOptionArray; },
/* harmony export */   "oP": function() { return /* binding */ matchBudgetOptionArray; },
/* harmony export */   "pQ": function() { return /* binding */ ApplyStep; },
/* harmony export */   "q1": function() { return /* binding */ companySizeOptionArray; },
/* harmony export */   "yE": function() { return /* binding */ positionOptionArray; }
/* harmony export */ });
var ApplyStep;
(function(ApplyStep) {
    ApplyStep[ApplyStep["회사정보"] = 0] = "회사정보";
    ApplyStep[ApplyStep["스코핑정보"] = 1] = "스코핑정보";
    ApplyStep[ApplyStep["예산정보"] = 2] = "예산정보";
    ApplyStep[ApplyStep["그외정보"] = 3] = "그외정보";
    ApplyStep[ApplyStep["회원정보"] = 4] = "회원정보";
    ApplyStep[ApplyStep["상담예약정보"] = 5] = "상담예약정보";
    ApplyStep[ApplyStep["상담예약완료"] = 6] = "상담예약완료";
    ApplyStep[ApplyStep["숏컨설팅제안"] = 7] = "숏컨설팅제안";
    ApplyStep[ApplyStep["매칭컨설팅없이매칭등록완료"] = 8] = "매칭컨설팅없이매칭등록완료";
})(ApplyStep || (ApplyStep = {}));
var companySizeOptionArray = [
    "10명 이하",
    "11~50명",
    "51~200명",
    "201~500명",
    "501명 이상", 
];
var matchPurposeOptionArray = [
    "정규직을 채용하기 위해서",
    "전문적인 자문을 받기 위해서",
    "파트타임 인력이 필요해서",
    "단기 프로젝트 인력이 필요해서", 
];
var matchJobOptionArray = [
    "마케팅",
    "디자인",
    "MD",
    "기타"
];
var matchBudgetOptionArray = [
    "4만원 이하",
    "4만원~7만원",
    "7만원~10만원",
    "10만원 이상"
];
var matchMonthBudgetOptionArray = [
    "100만원 이하",
    "100~200만원",
    "200~300만원",
    "300~500만원",
    "500만원 초과", 
];
var expectedWorkloadOptionArray = [
    "주 40시간",
    "주 20시간",
    "주 10시간",
    "주 5시간",
    "추후 결정", 
];
var estimatedBusinessDurationOptionArray = [
    "1개월 이내",
    "1~3개월",
    "3~6개월",
    "6개월 이상",
    "추후 결정", 
];
var desiredStartDateOptionArray = [
    "최대한 빨리",
    "2주 이내",
    "2~4주 이내",
    "4주 이후"
];
var companyIndustryOptionArray = [
    "소셜미디어/커뮤니티",
    "게임",
    "광고/마케팅",
    "교육",
    "금융/보험/핀테크",
    "모빌리티/교통",
    "물류",
    "부동산/건설",
    "뷰티/화장품",
    "블록체인/딥테크",
    "여행/레저",
    "유아/출산",
    "인사/비즈니스/법률",
    "제조/하드웨어",
    "커머스",
    "컨텐츠/예술",
    "통신/보안/데이터/개발",
    "패션",
    "푸드/농업",
    "헬스케어/바이오",
    "홈리빙/펫",
    "환경/에너지", 
];
var routeOptionArray = [
    "광고",
    "검색",
    "지인 추천",
    "블로그",
    "메일",
    "웨비나",
    "보도자료",
    "커뮤니티",
    "소셜미디어",
    "기타", 
];
var positionOptionArray = [
    "대표",
    "임원/C레벨",
    "팀장/리드",
    "실무자"
];


/***/ }),

/***/ 93293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cn": function() { return /* binding */ cn; },
/* harmony export */   "q": function() { return /* binding */ getConsultantImage; }
/* harmony export */ });
/* unused harmony export hashStringData */
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90512);
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42474);
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(crypto__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98388);



var hashStringData = function(str) {
    return crypto.createHash("sha256").update(str).digest("hex");
};
var getConsultantImage = function(consultant) {
    switch(consultant === null || consultant === void 0 ? void 0 : consultant.consultantRealName){
        case "최준순":
            {
                return "/onepoint/images/consultant/choi.jpeg";
            }
        default:
            {
                return "/onepoint/images/consultant/default.png";
            }
    }
};
function cn() {
    for(var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
        inputs[_key] = arguments[_key];
    }
    return (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_1__/* .twMerge */ .m6)((0,clsx__WEBPACK_IMPORTED_MODULE_2__/* .clsx */ .W)(inputs));
}


/***/ })

}]);